import { inject } from 'vue'

export const appContextKey = Symbol('app-context')

export function useAppContext() {
  const context = inject(appContextKey)
  if (!context) throw new Error('App context is not available')
  return context
}
